import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ObservationSummaryDTO } from '../model/observation/observation-summary-dto.model';
import { BaseApi, BASE_URL } from '@edl-development/edl-common';
import { UserSummaryPermissions } from '../model/observation/user-summary-permisions.model';
import { DuplicateObservationDTO } from '../model/observation/common/duplicate-observation-dto.model';
import { UpdateEvaluatorRequest } from '../model/observation/common/update-evaluator-request.model';

@Injectable()
export class ObservationListApi extends BaseApi {
  constructor(
    @Inject(BASE_URL) private baseUri: string,
    private http: HttpClient
  ) {
    super();
  }


  getUserSummary(userId: string, observationType: number, schoolYear: string) {
    return this.http.get<ObservationSummaryDTO[]>(this.baseUri + '/usersummary/' + userId + '/' + observationType + '/' + schoolYear, {});
  }

  getObservationSummary(userId: string, observationType: number, observationId: string) {
    return this.http.get<ObservationSummaryDTO>(this.baseUri + '/usersummary/' + userId + '/' + observationType + '/summary/' + observationId);
  }

  duplicateObservation(duplicateObservationDTO: DuplicateObservationDTO) {
    return this.http.post<ObservationSummaryDTO>(this.baseUri + '/usersummary/duplicate', duplicateObservationDTO);
  }

  reopenObservation(userId: string, observationType: number, observationId: string) {
    return this.http.put<boolean>(this.baseUri + '/usersummary/' + userId + '/' + observationType + '/reopen/' + observationId, {});
  }

  deleteObservation(userId: string, observationType: number, observationId: string) {
    return this.http.delete<boolean>(this.baseUri + '/usersummary/' + userId + '/' + observationType + '/delete/' + observationId);
  }

  reinstateObservation(userId: string, observationType: number, observationId: string) {
    return this.http.put(this.baseUri + '/usersummary/' + userId + '/' + observationType + '/reinstate/' + observationId, {});
  }

  updateSchoolYear(userId: string, observationType: number, observationId: string, schoolYear: string) {
    return this.http.patch(this.baseUri + '/usersummary/' + userId + '/' + observationType + '/' + observationId + '/updateSchoolYear/' + schoolYear, {});
  }

  updateEvaluator(request: UpdateEvaluatorRequest) {
    const { userId, observationType, observationId, evaluatorId, sendEmailNotification } = request;
    const params = new HttpParams()
      .append('sendEmailNotification', String(sendEmailNotification));

    return this.http.patch(
      this.baseUri + '/usersummary/' + userId + '/' + observationType + '/' + observationId + '/updateEvaluator/' + evaluatorId,
      {},
      { params }
    );
  }

  getUserSummaryPermissions(userId: string) {
    return this.http.get<UserSummaryPermissions>(`${this.baseUri}/usersummary/permissions/${userId}`, {});

  }
}
